import { DestinationsResponse, Place } from '@model/iceberg/geography';
import { Theme } from '@theme/base';
import { withTheme } from '@emotion/react';
import React from 'react';
import { Error500 } from '@components/common/hero/error/Error500';
import { PageProps } from '@model/pages';
import { TripTypes } from '@model/contentful';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { GetStaticProps } from 'next';
import { Page } from '@model/common';
import { DestinationLevel, getDestinationStaticPaths } from '@util/get-destination-static-paths';
import { GeographyApi } from '@model/iceberg';
import { getServerSidePropsVideoGuides } from '@layout/get-page-props/video-guides';
import { VideoGuidesListPageLayout } from '@layout/VideoGuidesListPageLayout/VideoGuidesListPageLayout';
import { ERROR_CODES } from '@model/common/error-codes';

export interface VideoGuidesCountryPageProps extends PageProps {
  theme: Theme;
  cmsConfig: any;
  place: Place;
  path: string;
  tripType: TripTypes;
}

const VideoGuidesCountryPage = (props: VideoGuidesCountryPageProps) => {
  const { cmsConfig } = props;
  if (!cmsConfig) return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;

  return <VideoGuidesListPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ req, params }: any) => {
  return await getServerSidePropsVideoGuides({ store, req, query: params, tripType: TripTypes.HOLIDAYS });
});

export async function getStaticPaths() {
  const destinations: DestinationsResponse = await new GeographyApi().getDestinations();
  const videoGuidesPath: string = Page.HOLIDAYS.concat(Page.VIDEO_GUIDES);
  const paths = getDestinationStaticPaths(destinations.destinations, DestinationLevel.COUNTRY, videoGuidesPath);
  return { paths, fallback: false };
}

export default withGlobalProvider(withTheme(VideoGuidesCountryPage));
